import { render } from "./SupportView.vue?vue&type=template&id=6e599a4e&scoped=true"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"

import "./SupportView.vue?vue&type=style&index=0&id=6e599a4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e599a4e"]])

export default __exports__